export const ROUTES = {
  // 運営会社
  ADMIN: {
    ROOT: "/admin",
    LOGIN: "/admin/login",
    LOGOUT: "/admin/logout",
    // HOME: "/admin/home",
    SPECIALIST: "/admin/specialist",
    PATTERN: "/admin/pattern",
    NOTIFICATION: "/admin/notification",
    HELP: "/admin/help",
  },

  // 専門家
  SPECIALIST: {
    ROOT: "/specialist",
    LOGIN: "/specialist/login",
    REGISTOR: "/specialist/registor",
    LOGOUT: "/specialist/logout",
    HOME: "/specialist/home",
    FINISH: "/specialist/finish",
  },
};
